import axios from 'axios';
import { clearLocalStoragePreservingPrefs } from '../../utils/clearLocalStoragePreservingPrefs';
import { buildLoginPath } from '../../utils';
import { installAxiosMock } from '../../api/mock';

const base = process.env.REACT_APP_SPARA_API_URL || 'https://api.spara.is';

const instance = axios.create({
    baseURL: base,
    headers: {
        'Content-Type': 'application/json',
        'APP-KEY': '3f8a97e6-51ea-44d7-a9c9-87ae6040f7fb',
        'Cache-Control': 'no-store',
    },
});

installAxiosMock(instance);

instance.interceptors.request.use((request) => {
    let store = localStorage.user ? JSON.parse(localStorage.getItem('user')) : '';
    if (store) {
        request.headers.Authorization = 'Bearer ' + store.access_token;
    }
    return request;
});

// Guard to prevent multiple simultaneous 401 responses from all triggering a redirect.
// Resets on page reload (hard navigation), which is the intended behaviour.
let isRedirectingToLogin = false;

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error('❌ Axios error:', {
            url: error.config?.url,
            status: error.response?.status,
            data: error.response?.data,
            message: error.message,
        });

        if (!axios.isCancel(error)) {
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                const hasToken = !!localStorage.getItem('user');
                console.warn('🔒 [middleware/axios] Got', error.response.status, 'from:', error.config?.method?.toUpperCase(), error.config?.url);
                console.warn('🔒 [middleware/axios] hasToken:', hasToken, '| isRedirecting:', isRedirectingToLogin);
                console.trace('🔒 [middleware/axios] Stack trace for', error.response.status);
                if (error?.response?.status === 401 && hasToken && !isRedirectingToLogin) {
                    isRedirectingToLogin = true;
                    console.warn('🔒 [middleware/axios] >>> CLEARING localStorage and redirecting to /auth/login');
                    clearLocalStoragePreservingPrefs();
                    window.location = buildLoginPath();
                }
            }
        }

        return Promise.reject(error);
    }
);

export default instance;
